(function ($) {

	setTimeout(function () {

		if (jQuery(".cart-wrapper").hasClass("simple-cart")) {
			jQuery("#shopify-section-footer").hide();
			jQuery("body").addClass("simple-cart-template");
		}


		// Slick Slider wird jetzt durch slider-lazy-loader.js geladen
		// Konfiguration ist in slider-lazy-loader.js verfügbar

		if (moment().day() === 0) { // Sunday

			var start_date = moment().add(2, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.from-date").html(start_date);

			var end_date = moment().add(4, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.to-date").html(end_date);

		} else if (moment().day() === 1) { // Monday

			var start_date = moment().add(1, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.from-date").html(start_date);

			var end_date = moment().add(4, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.to-date").html(end_date);

		} else if (moment().day() === 2) { // Tuesday

			var start_date = moment().add(1, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.from-date").html(start_date);

			var end_date = moment().add(6, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.to-date").html(end_date);

		} else if (moment().day() === 3) { // Wednesay

			var start_date = moment().add(1, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.from-date").html(start_date);

			var end_date = moment().add(6, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.to-date").html(end_date);

		} else if (moment().day() === 4) { // Thursday

			var start_date = moment().add(1, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.from-date").html(start_date);

			var end_date = moment().add(6, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.to-date").html(end_date);

		} else if (moment().day() === 5) { // Friday

			var start_date = moment().add(4, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.from-date").html(start_date);

			var end_date = moment().add(7, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.to-date").html(end_date);

		} else if (moment().day() === 6) { // Saturday

			var start_date = moment().add(3, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.from-date").html(start_date);

			var end_date = moment().add(6, 'days').format('DD.MM.YYYY');
			jQuery(".estimated-shipping.to-date").html(end_date);

		}

	}, 50);

})(theme.jQuery);